const convertSecondsToTime = (seconds) => {
    function fillLeftZero(propNumber) {
        return propNumber <= 9 ? `0${propNumber}` : propNumber;
    }

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours ? `${fillLeftZero(hours)}:` : ''}${fillLeftZero(minutes)}:${fillLeftZero(remainingSeconds)}`;
}

export { convertSecondsToTime };